export const NAME = 'ROOM';
export const SET_ROOMID= `${NAME}/SET_ROOMID`;
export const GET_ROOMDATA= `${NAME}/GET_ROOMDATA`;
export function setRoomId(id) {
  return {
    type: SET_ROOMID,
    id,
  };
}

export function getRoomData(data) {
  return {
    type: GET_ROOMDATA,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/redux/room/actions.js